export default "__VITE_ASSET__BUq35lg7__"